import { FormRow } from '@features/components/CaseFormBlocks/components';
import { ConditionalRender } from '@ui';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TmdxTextarea } from '@ds';
import { CaseTxCenterFormType } from '../EditCaseTxCenter/config';
import { checkShowTxCenterORChangeReason } from '../EditCaseTxCenter/utils';
import { Case } from '@/api/apis/case';

export const TxOrChangeReasonInput = ({ isDisabled, caseData }: { isDisabled: boolean; caseData: Case }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CaseTxCenterFormType>();

  const [
    recipientHospitalDate,
    recipientHospitalTime,
    recipientHospitalTimeZone,
    recipientHospitalORChangeReason,
    txCenterId,
  ] = useWatch<CaseTxCenterFormType>({
    control,
    name: [
      'recipientHospitalDate',
      'recipientHospitalTime',
      'recipientHospitalTimeZone',
      'recipientHospitalORChangeReason',
      'txCenterId',
    ],
  });

  const show = checkShowTxCenterORChangeReason(
    {
      recipientHospitalDate,
      recipientHospitalTime,
      recipientHospitalTimeZone,
      recipientHospitalORChangeReason,
      txCenterId,
    },
    caseData,
  );

  return (
    <ConditionalRender show={show}>
      <FormRow title="TX Center OR Change Reason" multiRow spitRows isRequired>
        <div className="flex flex-col gap-1">
          <Controller
            disabled={isDisabled}
            name="recipientHospitalORChangeReason"
            control={control}
            render={({ field: { value, ...rest }, fieldState: { invalid, error } }) => (
              <TmdxTextarea
                maxLength={128}
                disableAnimation
                minRows={2}
                aria-label="Tx Center OR Hospital change reason"
                isInvalid={invalid}
                errorMessage={error?.message}
                className="min-h-16"
                value={value || ''}
                {...rest}
              />
            )}
          />
          <ConditionalRender show={!errors.recipientHospitalORChangeReason}>
            <span className="text-s-r text-base-20">
              You are about to update the TX Center OR. Please provide a brief explanation (max length up to 128
              characters)
            </span>
          </ConditionalRender>
        </div>
      </FormRow>
    </ConditionalRender>
  );
};
